export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-950 to-background-800 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-14 overflow-hidden relative">
          <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none" />

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-smartphone-line mr-1"></i>移动观影
            </span>
            <h2 className="font-heading text-[28px] md:text-4xl text-background-50 mb-4">
              随时随地 · 掌上看片
            </h2>
            <p className="text-background-50/70 text-sm md:text-base max-w-md mx-auto lg:mx-0 leading-relaxed mb-6">
              51影院全面适配手机与平板，无需下载App，浏览器打开即可畅享全网影视，高清画质自动适配你的设备屏幕。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/15 text-background-50 text-sm font-medium border border-background-50/20 whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-apple-fill text-lg"></i>
                iOS 网页入口
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/15 text-background-50 text-sm font-medium border border-background-50/20 whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-android-fill text-lg"></i>
                Android 网页入口
              </span>
            </div>
          </div>

          <div className="relative z-10 flex-shrink-0 w-[200px] md:w-[240px]">
            <div className="aspect-[9/16] rounded-2xl bg-background-700/50 border border-background-50/10 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20showing%20movie%20streaming%20app%20interface%20with%20dark%20cinematic%20theme%2C%20film%20poster%20thumbnails%20in%20grid%20layout%2C%20warm%20golden%20accent%20colors%2C%20clean%20modern%20UI%20design%2C%20minimalist%20mobile%20screen%20mockup%20on%20dark%20background%2C%20high%20detail%20product%20shot&width=480&height=854&seq=app-mockup-01&orientation=portrait"
                alt="51影院移动端观影界面预览"
                className="w-full h-full object-cover"
                title="51影院移动端 - 随时随地看片"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}